import classNames from 'classnames';
import React, { Fragment } from 'react';
import { ChevronDown } from 'lucide-react';
import { Menu, Transition } from '@headlessui/react';

export default function ExpandDropdown({
  items,
  onClick,
  dropdownButtonText = '',
}) {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="py-2.5 px-5 text-base flex-row rounded-lg flex items-center justify-center gap-2 font-medium disabled:pointer-events-none disabled:opacity-60 bg-transparent text-primary hover:bg-muted">
          {dropdownButtonText}
          <ChevronDown aria-hidden="true" />
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
          <div className="flex flex-col px-1 py-1 gap-1">
            {items.map((item) => (
              <Menu.Item key={item.id}>
                {({ active }) => (
                  <button
                    onClick={() => onClick(item)}
                    className={classNames(
                      'group flex w-full items-center rounded-md px-2 py-2 text-sm text-gray-900',
                      {
                        'bg-primary text-white hover:bg-primary/90':
                          item.expandDropdownActive,
                        'hover:bg-primary/10 hover:text-gray-900':
                          active && !item.expandDropdownActive,
                      },
                    )}
                  >
                    {item.name}
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
